const { getAsyncJSON, postAsyncJSON } = require("./modules/shared");

function asyncFormSubmit(form, successFn, errorFn) {
    // use form action for url
    const action = form.attr("action");

    // turn serialized form data array into json
    const data = {};
    _.each(form.serializeArray(), function (input) {
        data[input.name] = input.value;
    });

    // derive what async function to call from form method
    let asyncMethodFunction = "";
    switch (form.attr("method")) {
        case "POST":
            asyncMethodFunction = postAsyncJSON;
            break;
        case "GET":
        default:
            asyncMethodFunction = getAsyncJSON;
            break;
    }

    // api call
    asyncMethodFunction(
        action,
        data,
        "",
        function (result) {
            if (result.success) {
                // success function
                if (successFn && typeof successFn === "function") {
                    successFn(result);
                }
            } else {
                // error function
                if (errorFn && typeof errorFn === "function") {
                    errorFn(result);
                }
            }
        },
        function (error) {
            // legit error
            if (errorFn && typeof errorFn === "function") {
                errorFn(error);
            }
        }
    );
}

module.exports = {
    asyncFormSubmit,
};
